import React, {Component} from "react";
import styled from 'styled-components'

const DisabledContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: black;
  color: white;
  display: flex;
`

const Text = styled.h1`
  display: block;
  margin: auto;
  color: white;
`

export default class TVDisabledPage extends Component {
  render() {
    return (
      <DisabledContainer data-cy='disabled-container'>
        <Text>
          This device is disabled in backoffice, please contact support.
        </Text>
      </DisabledContainer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/tv_disabled_page.js